
import axios from "axios";

export const state = {
    staffdeductions: [],
};

export const getters = {
    staffdeductions: state => state.staffdeductions,
};

export const mutations = {
    setStaffDeductions(state, newValue) {
        state.staffdeductions = newValue
    },
};

export const actions = {
    fetchStaffDeductions({ commit }) {
        axios.get('/staffdeductions').then(res => {
            commit('setStaffDeductions', res.data.staffdeductions);
        })
    },
};
